import type { CourseData } from '../types/course';

const STORAGE_KEYS = {
  COURSE_SELECTIONS: 'yoga-course-selections',
  PAST_COURSES: 'yoga-past-courses',
} as const;

export function loadFromStorage<T>(key: keyof typeof STORAGE_KEYS): T | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS[key]);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error(`Error loading from storage (${key}):`, error);
    return null;
  }
}

export function saveToStorage(key: keyof typeof STORAGE_KEYS, data: any): void {
  try {
    localStorage.setItem(STORAGE_KEYS[key], JSON.stringify(data));
  } catch (error) {
    console.error(`Error saving to storage (${key}):`, error);
  }
}

export function loadCourseSelections(): CourseData | null {
  return loadFromStorage('COURSE_SELECTIONS');
}

export function saveCourseSelections(courseData: CourseData): void {
  // Create a copy of the data with only the selected courses
  const selectedCourses: CourseData = {
    asanas: courseData.asanas.filter((course) => course.selected),
    meditation: courseData.meditation.filter((course) => course.selected),
    'other offerings': courseData['other offerings'].filter(
      (course) => course.selected
    ),
  };

  // Save only the selected courses to reduce storage size
  saveToStorage('COURSE_SELECTIONS', selectedCourses);
}
